import { createTheme } from '@mui/material/styles';

export const createAppTheme = direction => createTheme({
  direction,
  palette: {
    mode: 'light',
    primary: { main: '#1565C0', light: '#42A5F5', dark: '#0D47A1' },
    secondary: { main: '#00897B' },
    success: { main: '#2E7D32', light: '#E8F5E9' },
    warning: { main: '#F57C00', light: '#FFF3E0' },
    error: { main: '#D32F2F', light: '#FFEBEE' },
    info: { main: '#1565C0', light: '#E3F2FD' },
    background: { default: '#F8FAFC', paper: '#FFFFFF' },
    text: { primary: '#1E293B', secondary: '#64748B', disabled: '#94A3B8' },
    divider: '#E2E8F0',
  },
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 14,
    h1: { fontSize: '1.875rem', fontWeight: 700, lineHeight: 1.25 },
    h2: { fontSize: '1.5rem', fontWeight: 600, lineHeight: 1.3 },
    h3: { fontSize: '1.25rem', fontWeight: 600, lineHeight: 1.4 },
    h4: { fontSize: '1.125rem', fontWeight: 600, lineHeight: 1.4 },
    h5: { fontSize: '1rem', fontWeight: 600, lineHeight: 1.5 },
    h6: { fontSize: '1rem', fontWeight: 600, lineHeight: 1.5 },
    body1: { fontSize: '0.875rem', lineHeight: 1.5 },
    body2: { fontSize: '0.8125rem', lineHeight: 1.5 },
    caption: { fontSize: '0.75rem', lineHeight: 1.5 },
    button: { fontSize: '0.875rem', fontWeight: 500, textTransform: 'none' },
  },
  shape: { borderRadius: 8 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '*:focus-visible': { outline: '2px solid #1565C0', outlineOffset: 2 },
        body: { backgroundColor: '#F8FAFC' },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { minHeight: 40, borderRadius: 4 } },
    },
    MuiTextField: { defaultProps: { size: 'small' } },
    MuiOutlinedInput: { styleOverrides: { root: { borderRadius: 4, backgroundColor: '#FFFFFF' } } },
    MuiPaper: { defaultProps: { elevation: 0 }, styleOverrides: { root: { backgroundImage: 'none' } } },
    MuiCard: { defaultProps: { elevation: 0 }, styleOverrides: { root: { border: '1px solid #E2E8F0' } } },
    MuiTableCell: {
      styleOverrides: {
        root: { padding: '12px 16px', borderColor: '#E2E8F0' },
        head: { backgroundColor: '#F8FAFC', fontSize: '0.75rem', fontWeight: 600, textTransform: 'uppercase' },
      },
    },
  },
});
